enum ExternalLinks {
  E_VERIFY = 'https://www.e-verify.gov',
  MFA_MIGRATION = 'https://www.e-verify.gov/access-e-verify-with-logingov',
  E_VERIFY_PLUS_EMAIL = 'E-VerifyPlus@uscis.dhs.gov',
  E_VERIFY_PLUS = 'https://www.e-verify.gov/plus',
  E_VERIFY_WHATS_NEW = 'https://www.e-verify.gov/about-e-verify/whats-new',
}

export default ExternalLinks;
